var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg003Note(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "36px",
    viewBox: "0 0 33 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 53 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.186790063 8.49619984 0.186790063 8.49619984 6.77370174 0 6.77370174"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tom",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#39C5EE",
    points: "6.7251833 9.84015609 6.7251833 35.5893746 27.6972646 35.5893746 32.4967352 30.7903063 32.4967352 9.84015609"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#1192C5",
    points: "10.9566207 20.1751544 28.1028474 20.1751544 28.1028474 18.5681547 10.9566207 18.5681547"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#1192C5",
    points: "10.9566207 24.7828797 28.1028474 24.7828797 28.1028474 23.1760811 10.9566207 23.1760811"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#1192C5",
    points: "10.9566207 29.3912085 28.1028474 29.3912085 28.1028474 27.7842088 10.9566207 27.7842088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#1192C5",
    points: "27.697345 30.7902258 27.697345 35.5894953 32.4968157 30.7902258"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#21A8D2",
    points: "6.72514306 15.0036614 32.496695 15.0036614 32.496695 9.84001525 6.72514306 9.84001525"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#1192C5",
    points: "6.72514306 15.3249809 32.496695 15.3249809 32.496695 14.6825431 6.72514306 14.6825431"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(6.428571, 14.242251)",
    fill: "#C1E7F4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    points: "0.296772837 1.72516772 26.0681236 1.72516772 26.0681236 1.08272998 0.296772837 1.08272998"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.62245141,16.0101836 C8.57929359,16.0242007 8.53724239,16.0282583 8.49371571,16.0426442 L11.607349,20.8283661 L10.0429705,15.3746203 C9.59848194,15.6232388 9.12595922,15.8405033 8.62245141,16.0101836",
    id: "Fill-10",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25684998,6.8302218 C9.5272531,5.73320185 12.7054387,6.89809392 13.3594455,9.4314944 C14.0123458,11.9660015 11.8928176,14.9121677 8.62241452,16.0102943 C5.35201139,17.1091586 2.1716126,15.9442665 1.51871236,13.4086528 C0.865074375,10.8730391 2.98755346,7.92908611 6.25684998,6.8302218",
    id: "Fill-12",
    fill: "#C13833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89141028,5.99808754 C9.1197622,4.91397804 12.2699136,6.10174006 12.9250271,8.65469066 C13.5841981,11.2039526 11.5019259,14.1519631 8.27246737,15.2382859 C5.04411544,16.3216576 1.89617722,15.132789 1.23663732,12.5798384 C0.579679507,10.029101 2.66453383,7.08219703 5.89141028,5.99808754",
    id: "Fill-14",
    fill: "#F27273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9249902,8.65458 C12.8394123,8.31632603 12.7055125,8.00278637 12.5358322,7.71543649 C12.6007533,7.87109971 12.6590348,8.03303373 12.701086,8.2016074 C13.3595193,10.7519759 11.2735584,13.7007242 8.04336209,14.7844649 C5.24658829,15.7236084 2.5066205,14.9534074 1.40000993,13.0670052 C2.3111193,15.2772754 5.25617892,16.2488795 8.27243048,15.2385441 C11.501889,14.1522213 13.5845301,11.2038419 12.9249902,8.65458",
    id: "Fill-16",
    fill: "#F7B1B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96052803,9.11061422 C10.497603,10.3566577 9.79195435,11.8199658 8.38360796,12.3776975 L7.6034475,12.6868107 C6.19620772,13.2456491 4.62039425,12.6868107 4.0814749,11.4429804 L1.30388236,4.99623609 C0.766807356,3.74908597 1.47208716,2.28799114 2.88154017,1.7291528 L3.66096288,1.41893297 C5.0678338,0.861201238 6.64586048,1.41893297 7.18404209,2.66608309 L9.96052803,9.11061422 Z",
    id: "Fill-18",
    fill: "#E94F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68232047,1.07632633 C6.02427732,0.309076334 8.24856458,1.01878258 8.65616614,2.66062381 C9.06266109,4.30246504 7.49643826,6.25637044 5.15780124,7.02362044 C2.81547552,7.79234593 0.591557127,7.08190194 0.183955565,5.44042958 C-0.223277127,3.79785061 1.34368345,1.84357633 3.68232047,1.07632633",
    id: "Fill-20",
    fill: "#C13833"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50511523,0.486281575 C5.81498037,-0.27027119 8.02045525,0.456034219 8.43027004,2.10746607 C8.83971595,3.76111114 7.2996829,5.71612316 4.9879734,6.47488915 C2.67958374,7.22996643 0.475953209,6.5051365 0.0661384255,4.85149143 C-0.344414099,3.19563314 1.19783218,1.24504756 3.50511523,0.486281575",
    id: "Fill-22",
    fill: "#F27273",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.98778897,6.02077305 C2.6793993,6.77843243 0.475768774,6.05212702 0.0663228606,4.39885082 C0.0412396875,4.29814925 0.0242716587,4.1985543 0.0132055529,4.09600839 C-0.00708230769,4.35126656 0.00582814904,4.60394264 0.0663228606,4.85145454 C0.475768774,6.50509962 2.6793993,7.22992954 4.98778897,6.47485226 C7.15932779,5.7603507 8.64956337,3.99309361 8.48098969,2.41027161 C8.35778704,3.86583339 6.9549737,5.37746344 4.98778897,6.02077305",
    id: "Fill-25",
    fill: "#F7B1B3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg003Note);
export default __webpack_public_path__ + "static/media/003-note.7370cac7b6fc0b6acb7fb4e437f44b0e.svg";
export { ForwardRef as ReactComponent };